import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { useSearchParams } from 'react-router-dom'

const Error = () => {
  const [searchParams] = useSearchParams()
  const errorCode = searchParams.get('error')

  const title = () => {
    switch (errorCode) {
      case 'domain_blocked':
        return 'Thank you for your interest in Jelled. You’ve been added to the waitlist. We will reach out to you when the product is out of private beta.'
      case 'email_not_found':
        return "Please enable 'profile' scope in your SSO configuration to sign up."
      case 'personal_email_not_allowed':
        return 'Please use a work email to sign up.'
      case 'verify_code_invalid':
        return 'This email verification link has expired. Another email has just been sent, please try again from there.'
      case 'reset_password_code_invalid':
        return 'This reset password link has expired. Another email has just been sent, please try again from there.'
      case 'invalid_auth_provider':
        return 'Your organization is not using SSO for authentication. Please try your email and password to sign in.'
      case 'org_exists':
        return 'Your domain already exists as an organization in Jelled. Your admin will be contacted to send you an invite.'
      case 'session_expired':
        return 'Your SSO session has expired. Please try to login again.'
      case 'sso_not_configured':
        return 'SSO is not configured for your organization.'
      default:
        return 'An unknown error occurred'
    }
  }

  const redirectionUrl = () => {
    switch (errorCode) {
      case 'personal_email_not_allowed':
        return 'https://app.jelled.ai'
      default:
        return 'https://www.jelled.ai'
    }
  }

  return (
    <Dialog open={true}>
      <DialogTitle>{title()}</DialogTitle>
      <DialogActions>
        <Button variant="contained" color="secondary" component="a" href={redirectionUrl()}>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Error
